module.exports = __webpack_public_path__ + "img/3.ac0ac62c.jpg";